export const MIN_LUNCH_SERVINGS = 0;
export const MAX_LUNCH_SERVINGS = 10;
